import React, { useEffect } from 'react';

import { datadogRum } from '@datadog/browser-rum';

import { FeatureFlagsKeysEnum } from 'common/constants/FeatureFlags';

import { useFeatureFlag } from 'hooks/useFeatureFlags';

const {
	REACT_APP_DATADOG_APPLICATION_ID: applicationId,
	REACT_APP_DATADOG_CLIENT_TOKEN: clientToken,
	REACT_APP_ENVIRONMENT: environment,
} = process.env;

const initializeDataDog = () => {
	datadogRum.init({
		applicationId: applicationId as string,
		clientToken: clientToken as string,
		site: 'us3.datadoghq.com',
		service: 'risklink',
		env: environment,
		sessionSampleRate: 100,
		sessionReplaySampleRate: 0,
		trackUserInteractions: true,
		trackResources: true,
		trackLongTasks: true,
		useSecureSessionCookie: true,
		defaultPrivacyLevel: 'mask-user-input',
	});
};

interface IDataDogProps {
	children: React.ReactNode;
}

const DataDogProvider = (props: IDataDogProps) => {
	const { children } = props;
	const isDataDogEnabled = useFeatureFlag(
		FeatureFlagsKeysEnum.IS_DATADOG_ENABLED,
	);

	useEffect(() => {
		if (isDataDogEnabled) {
			initializeDataDog();
		}
	}, [isDataDogEnabled]);

	return <div>{children}</div>;
};

export default DataDogProvider;
